import ReactDOM from 'react-dom';
import { _process, search as newSearchService } from '../newSearch';
import { getFilterTypeHandler } from './getTypes';
import { getResultCountHandler } from './getResultCount';
import { getTopHit } from './getTopHit';
import { SEARCH_FILTERS } from 'state/Search/constants';

export const newSearchHandler = component => {
  return (country, isShowMoreClick) => {
    const getFilterType = getFilterTypeHandler(component);
    const getResultCount = getResultCountHandler(component);
    const {
      ampUrl,
      host,
      profileId,
      searchQuery,
      searchFilter,
      sessionId,
      currentMarket,
    } = component.props;
    const { nextPage } = component.state.result ?? null;
    const marketId = currentMarket?.marketId ?? null;
    const { filter = SEARCH_FILTERS.ALL } = getFilterType(searchFilter);

    const { dialog } = component;
    const searchDialog = ReactDOM.findDOMNode(dialog); // eslint-disable-line

    const opts = {
      countryCode: country,
    };

    // scroll to top for new searches
    if (!isShowMoreClick && searchDialog) searchDialog.scrollTop = 0;

    return newSearchService(
      searchQuery,
      filter,
      opts,
      profileId,
      sessionId,
      ampUrl,
      host,
      marketId,
      nextPage,
    ).then(async data => {
      const newState = {
        limit: component.state.limit,
        result: _process(data),
        selected: 0,
        topHit: await getTopHit(data.bestMatch),
        queryId: data.queryId,
      };

      newState.resultCount = getResultCount(newState);

      return newState;
    });
  };
};
